import { render, staticRenderFns } from "./VxPrompt.vue?vue&type=template&id=550ffe98"
import script from "./VxPrompt.vue?vue&type=script&lang=js"
export * from "./VxPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports